<template>
  <div class="d-flex">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon>
          <v-icon color="primary">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item :disabled="!$auth.policies['update-attendance']">
          <v-list-item-title style="cursor: pointer" @click="editDialog = !editDialog"
            ><v-icon>mdi-pencil</v-icon></v-list-item-title
          >
        </v-list-item>
      </v-list>
    </v-menu>

    <EditBoardingClassAttendanceDialog
      :selectedAttendance="selectedAttendance"
      :checkinObject="checkinObject"
      :state="editDialog"
      @attendanceUpdated="$emit('attendanceUpdated')"
    />
  </div>
</template>

<script>
import EditBoardingClassAttendanceDialog from './EditBoardingClassAttendanceDialog.vue'

export default {
  props: {
    selectedAttendance: Object,
    checkinObject: {
      type: Object,
      default: null,
    },
  },
  components: {
    EditBoardingClassAttendanceDialog,
  },

  data() {
    return {
      editDialog: false,
    }
  },
}
</script>
